export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '7f5f6df', dateTime: 1775242842321 };